import { render, staticRenderFns } from "./AdminInitialsEditScreen.vue?vue&type=template&id=4b3382c6&scoped=true&"
import script from "./AdminInitialsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminInitialsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3382c6",
  null
  
)

export default component.exports